import { render, staticRenderFns } from "./Delegation-form.vue?vue&type=template&id=da885aae"
import script from "./Delegation-form.vue?vue&type=script&lang=js"
export * from "./Delegation-form.vue?vue&type=script&lang=js"
import style0 from "./Delegation-form.vue?vue&type=style&index=0&id=da885aae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports